/**
 * Start Here Quiz — goal-based homepage quiz.
 * Multi-select goals (per Gaby's spec): pick one or more goals, or "all of the above".
 * Ends by adding the chosen item straight to cart and redirecting to /cart.
 */
(function () {
  'use strict';

  var GOAL_ORDER = ['weight', 'energy', 'sleep', 'hormonal', 'digestion'];

  var GOALS = [
    { id: 'weight', es: 'Bajar de peso', en: 'Weight loss', icon: '⚖️' },
    { id: 'energy', es: 'Energía', en: 'Energy', icon: '⚡' },
    { id: 'sleep', es: 'Dormir mejor', en: 'Sleep', icon: '🌙' },
    { id: 'hormonal', es: 'Balance hormonal', en: 'Hormonal balance', icon: '🧬' },
    { id: 'digestion', es: 'Digestión', en: 'Digestion', icon: '🌿' },
    { id: 'all', es: 'Todo esto', en: 'All of the above', icon: '✨' }
  ];

  var GENDER_OPTIONS = [
    { id: 'f', es: 'Mujer', en: 'Woman' },
    { id: 'm', es: 'Hombre', en: 'Man' }
  ];

  var FOLLOWUPS = {
    weight: [
      {
        text: { es: '¿En qué parte del cuerpo acumula más?', en: 'Where do you carry the most stubborn weight?' },
        options: [
          { id: 'belly', es: 'Abdomen', en: 'Belly / abdomen' },
          { id: 'hips', es: 'Caderas y muslos', en: 'Hips & thighs' },
          { id: 'all', es: 'En todo el cuerpo', en: 'All over' }
        ]
      },
      {
        text: { es: '¿Cómo describiría su nivel de actividad?', en: 'How active is your day-to-day?' },
        options: [
          { id: 'sedentary', es: 'Sedentario, casi no hago ejercicio', en: 'Sedentary — little to no exercise' },
          { id: 'active_job', es: 'Trabajo físico o activo', en: 'Active job or lifestyle' },
          { id: 'exercise_stuck', es: 'Hago ejercicio pero no bajo', en: 'I work out but still struggle' }
        ]
      }
    ],
    energy: [
      {
        text: { es: '¿Qué porcentaje de energía siente en un día normal?', en: "What % of a full day's energy do you feel you have?" },
        options: [
          { id: '20', es: '20%', en: '20%' },
          { id: '40', es: '40%', en: '40%' },
          { id: '60', es: '60%', en: '60%' },
          { id: '80', es: '80% o más', en: '80% or more' }
        ]
      },
      {
        text: { es: '¿Qué usa normalmente para tener energía?', en: 'What do you usually lean on for energy?' },
        options: [
          { id: 'caffeine', es: 'Café o bebidas energizantes', en: 'Coffee or energy drinks' },
          { id: 'sugar', es: 'Azúcar o comida', en: 'Sugar or food' },
          { id: 'push_through', es: 'Nada, solo empujo el día', en: 'Nothing — I just push through' }
        ]
      }
    ],
    sleep: [
      {
        text: { es: 'Del 1 al 10, ¿cómo calificaría su calidad de sueño?', en: 'On a scale of 1–10, how would you rate your sleep quality?' },
        options: [
          { id: 'low', es: '1-3, muy mal', en: '1–3, poor' },
          { id: 'mid', es: '4-6, regular', en: '4–6, okay' },
          { id: 'high', es: '7-10, bien', en: '7–10, good' }
        ]
      },
      {
        text: { es: '¿Qué le pasa la mayoría de las noches?', en: 'What happens most nights?' },
        options: [
          { id: 'falling_asleep', es: 'Batallo para quedarme dormido/a', en: 'I struggle to fall asleep' },
          { id: 'waking_up', es: 'Me despierto varias veces', en: 'I wake up a lot during the night' },
          { id: 'tired_anyway', es: 'Me levanto cansado/a de todas formas', en: 'I wake up tired no matter what' }
        ]
      }
    ],
    digestion: [
      {
        text: { es: '¿Qué síntoma tiene con más frecuencia?', en: 'What shows up most?' },
        options: [
          { id: 'bloating', es: 'Gases o hinchazón después de comer', en: 'Bloating / gas after eating' },
          { id: 'irregular', es: 'Problemas para ir al baño', en: 'Irregular bathroom habits' },
          { id: 'reflux', es: 'Reflujo o acidez', en: 'Reflux or heartburn' },
          { id: 'sluggish', es: 'Pesadez después de comer', en: 'Heavy, sluggish after meals' }
        ]
      },
      {
        text: { es: '¿Desde hace cuánto tiempo?', en: 'How long has this been going on?' },
        options: [
          { id: 'weeks', es: 'Unas semanas', en: 'A few weeks' },
          { id: 'months', es: 'Varios meses', en: 'Months' },
          { id: 'years', es: 'Años, de forma intermitente', en: 'Years, on and off' }
        ]
      }
    ],
    hormonal_f: [
      {
        text: { es: '¿Ha notado cambios hormonales (ánimo, cabello, peso)?', en: 'Noticed hormonal shifts — mood, hair, weight distribution?' },
        options: [
          { id: 'recent', es: 'Sí, recientemente', en: 'Yes, lately' },
          { id: 'while', es: 'Sí, desde hace tiempo', en: 'Yes, for a while' },
          { id: 'unsure', es: 'No estoy segura', en: 'Not sure' }
        ]
      }
    ],
    hormonal_m: [
      {
        text: { es: '¿Ha notado menos fuerza, energía o motivación?', en: 'Noticed lower drive, strength, or motivation?' },
        options: [
          { id: 'recent', es: 'Sí, recientemente', en: 'Yes, lately' },
          { id: 'while', es: 'Sí, desde hace tiempo', en: 'Yes, for a while' },
          { id: 'optimize', es: 'No tanto, solo quiero optimizar', en: 'Not really — just want to optimize' }
        ]
      }
    ]
  };

  var FULL_PROGRAM = {
    handle: 'relaxslim-program-free-shipping',
    variantId: 41980098019412,
    image: 'https://cdn.shopify.com/s/files/1/0068/7279/3172/files/Programa_personal_-_colageno.png?v=1768938399',
    es: { name: 'Programa Personal de NaturalSlim®', desc: 'El sistema completo: dieta 3x1, apoyo de un consultor y los suplementos correctos para su meta.' },
    en: { name: 'NaturalSlim Personal Program', desc: 'The complete system: 3x1 diet, consultant support, and the right supplements for your goal.' }
  };

  var KITS = {
    weight: { handle: 'candiseptic-kit', variantId: 22088888975444, image: 'https://cdn.shopify.com/s/files/1/0068/7279/3172/files/CandisepticKitLibroEPDM.png?v=1778336046', es: { name: 'Candiseptic Kit', desc: 'Limpieza de hongo cándida de 28 días — ataca la raíz que frena el metabolismo.' }, en: { name: 'Candiseptic Kit', desc: '28-day candida cleanse — targets the root cause slowing your metabolism.' } },
    energy: { handle: 'kit-energia-abundante', variantId: 32017235804244, image: 'https://cdn.shopify.com/s/files/1/0068/7279/3172/products/Kit-energia-abundante2022_1_2dc4c4b1-fb88-4da6-aa50-5195adcc4bfe.jpg?v=1767202421', es: { name: 'Kit Energía Abundante', desc: 'Diseñado para las personas cuyo problema principal es la falta de energía.' }, en: { name: 'Abundant Energy Kit', desc: 'Built for when low energy is the main thing getting in your way.' } },
    sleep: { handle: 'kit-sueno-reparador', variantId: 32154232619092, image: 'https://cdn.shopify.com/s/files/1/0068/7279/3172/files/naturalslim-frank-suarez-metabolismotv-unimetab-metabolismo-adelgazar-rebajar-candida-dieta-metabolismo-quiero-rebajar-kit-sueno-reparador-magicmag-stress-defender-y-passivoil-disenad.png?v=1780407546', es: { name: 'NoctiKit', desc: 'NoctiBurn, NoctiSleep y PassivOil para un sueño reparador de verdad.' }, en: { name: 'NoctiKit', desc: 'NoctiBurn, NoctiSleep and PassivOil for real, restorative sleep.' } },
    digestion: { handle: 'kit-limpieza-intestinal-profunda', variantId: 32154233569364, image: 'https://cdn.shopify.com/s/files/1/0068/7279/3172/files/Limpieza_Intestinal_Profunda_Special.png?v=1788610448', es: { name: 'Limpieza Intestinal Profunda', desc: 'Para gases, hinchazón e irregularidad — enzimas y limpieza en un solo kit.' }, en: { name: 'Deep Intestinal Cleanse', desc: 'For gas, bloating and irregularity — enzymes and cleanse in one kit.' } },
    hormonal_f: { handle: 'femme-support', variantId: 47609163350100, image: 'https://cdn.shopify.com/s/files/1/0068/7279/3172/files/Femme_Support_Kit.png?v=1792007646', es: { name: 'Femme Support', desc: 'Apoyo hormonal formulado para las necesidades de la mujer.' }, en: { name: 'Femme Support', desc: "Hormonal support formulated for women's needs." } },
    hormonal_m: { handle: 'kit-salud-masculina-caballeros', variantId: 41108459618388, image: 'https://cdn.shopify.com/s/files/1/0068/7279/3172/files/Artboard_2.png?v=1788528487', es: { name: 'Kit de Ayuda Masculina', desc: 'Vitalidad, fuerza y balance hormonal para caballeros.' }, en: { name: "Men's Support Kit", desc: 'Vitality, strength and hormonal balance for men.' } },
    all: { handle: 'candiseptic-kit', variantId: 22088888975444, image: 'https://cdn.shopify.com/s/files/1/0068/7279/3172/files/CandisepticKitLibroEPDM.png?v=1778336046', es: { name: 'Candiseptic Kit', desc: 'El primer paso del sistema completo — empiece por aquí mientras decide sobre el programa.' }, en: { name: 'Candiseptic Kit', desc: 'The first step of the full system — start here while you consider the program.' } }
  };

  function track(eventName, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
    } catch (e) { /* no-op */ }
  }

  function el(tag, cls, html) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (html != null) node.innerHTML = html;
    return node;
  }

  function addToCart(variantId, button, locale) {
    button.disabled = true;
    button.textContent = locale === 'en' ? 'Adding…' : 'Agregando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add to cart failed');
        return res.json();
      })
      .then(function () {
        track('nsq_add_to_cart', { variant_id: variantId });
        window.location.href = '/cart';
      })
      .catch(function () {
        window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
      });
  }

  function Quiz(root) {
    this.root = root;
    this.locale = root.getAttribute('data-locale') === 'en' ? 'en' : 'es';
    this.state = { goals: [], gender: null, answers: {}, stepIndex: 0, steps: ['goal'] };
    this.render();
    track('nsq_quiz_viewed', { locale: this.locale });
  }

  Quiz.prototype.t = function (pair) {
    return pair[this.locale] || pair.es;
  };

  Quiz.prototype.hasHormonal = function () {
    return this.state.goals.indexOf('hormonal') !== -1;
  };

  Quiz.prototype.followKeyFor = function (goalId) {
    if (goalId === 'hormonal') return this.state.gender === 'm' ? 'hormonal_m' : 'hormonal_f';
    return goalId;
  };

  Quiz.prototype.computeSteps = function () {
    if (this.state.goals.indexOf('all') !== -1) {
      return ['goal', 'result'];
    }
    var steps = ['goal'];
    if (this.hasHormonal()) steps.push('gender');
    var orderedGoals = GOAL_ORDER.filter(function (g) { return this.state.goals.indexOf(g) !== -1; }, this);
    orderedGoals.forEach(function (goalId) {
      var followKey = this.followKeyFor(goalId);
      var questions = FOLLOWUPS[followKey] || [];
      questions.forEach(function (_, i) { steps.push(goalId + '__q' + i); });
    }, this);
    steps.push('result');
    return steps;
  };

  Quiz.prototype.toggleGoal = function (goalId) {
    var goals = this.state.goals;
    if (goalId === 'all') {
      this.state.goals = goals.indexOf('all') !== -1 ? [] : ['all'];
    } else {
      var idx = goals.indexOf(goalId);
      if (idx !== -1) {
        goals.splice(idx, 1);
      } else {
        var allIdx = goals.indexOf('all');
        if (allIdx !== -1) goals.splice(allIdx, 1);
        goals.push(goalId);
      }
    }
    this.render();
  };

  Quiz.prototype.goNext = function () {
    this.state.steps = this.computeSteps();
    if (this.state.stepIndex < this.state.steps.length - 1) {
      this.state.stepIndex += 1;
      this.render();
    }
  };

  Quiz.prototype.goBack = function () {
    if (this.state.stepIndex > 0) {
      this.state.stepIndex -= 1;
      this.render();
    }
  };

  Quiz.prototype.confirmGoals = function () {
    if (!this.state.goals.length) return;
    track('nsq_goals_selected', { goals: this.state.goals.join(','), locale: this.locale });
    this.goNext();
  };

  Quiz.prototype.selectGender = function (genderId) {
    this.state.gender = genderId;
    this.goNext();
  };

  Quiz.prototype.answerQuestion = function (stepKey, optionId) {
    this.state.answers[stepKey] = optionId;
    this.goNext();
  };

  Quiz.prototype.restart = function () {
    this.state = { goals: [], gender: null, answers: {}, stepIndex: 0, steps: ['goal'] };
    this.render();
  };

  Quiz.prototype.renderOptionGrid = function (options, onPick, isSelected) {
    var wrap = el('div', 'nsq__options');
    var self = this;
    options.forEach(function (opt) {
      var selected = isSelected(opt.id);
      var label = (opt.icon ? opt.icon + ' ' : '') + self.t(opt);
      var btn = el('button', 'nsq__option' + (selected ? ' nsq__option--selected' : ''), label);
      btn.type = 'button';
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      btn.addEventListener('click', function () { onPick(opt.id); });
      wrap.appendChild(btn);
    });
    return wrap;
  };

  Quiz.prototype.render = function () {
    var self = this;
    // Recompute every render so the step count (and the "question X of Y" label)
    // always reflects the current goal/gender selections, including while still
    // on the goal-picking screen -- that screen counts as question 1.
    this.state.steps = this.computeSteps();
    var steps = this.state.steps;
    var current = steps[this.state.stepIndex];
    this.root.innerHTML = '';

    var panel = el('div', 'nsq__panel');

    var badge = el('div', 'nsq__badge', this.t({ es: 'COMIENCE AQUÍ', en: 'START HERE' }));
    panel.appendChild(badge);

    if (steps.length > 1 && this.state.goals.length > 0) {
      var progress = el('div', 'nsq__progress');
      var questionTotal = steps.length - 1;
      var questionNum = Math.min(this.state.stepIndex + 1, questionTotal);
      var label = el('span', 'nsq__progress-label', this.t({ es: 'Pregunta', en: 'Question' }) + ' ' + questionNum + ' ' + this.t({ es: 'de', en: 'of' }) + ' ' + questionTotal);
      if (current !== 'result') panel.appendChild(label);
      var bar = el('div', 'nsq__progress-bar');
      steps.forEach(function (s, i) {
        var seg = el('div', 'nsq__progress-seg');
        if (i <= self.state.stepIndex) seg.setAttribute('data-active', 'true');
        bar.appendChild(seg);
      });
      panel.appendChild(bar);
    }

    if (current === 'goal') {
      panel.appendChild(el('h2', 'nsq__title', this.t({ es: '¿Qué le gustaría mejorar?', en: 'What would you like to improve?' })));
      panel.appendChild(el('p', 'nsq__subtitle', this.t({ es: 'Responda estas tres preguntas sencillas y le guiaremos en su primer paso con NaturalSlim.', en: "Answer these three simple questions, and we'll guide your first step with NaturalSlim." })));
      panel.appendChild(this.renderOptionGrid(GOALS, function (id) { self.toggleGoal(id); }, function (id) { return self.state.goals.indexOf(id) !== -1; }));
      var cta = el('button', 'nsq__cta', this.t({ es: 'Continuar →', en: 'Continue →' }));
      cta.type = 'button';
      cta.disabled = !this.state.goals.length;
      cta.addEventListener('click', function () { self.confirmGoals(); });
      panel.appendChild(cta);
      var footerLink = el('a', 'nsq__footer-link', this.t({ es: 'Prefiero ver todos los productos', en: "I'd rather browse all products" }));
      footerLink.href = '/collections/productos-naturalslim%C2%AE';
      panel.appendChild(footerLink);
    } else if (current === 'gender') {
      panel.appendChild(el('p', 'nsq__question', this.t({ es: 'Para afinar la recomendación:', en: 'To fine-tune your recommendation:' })));
      panel.appendChild(this.renderOptionGrid(GENDER_OPTIONS, function (id) { self.selectGender(id); }, function (id) { return self.state.gender === id; }));
      panel.appendChild(this.renderNav());
    } else if (current && current.indexOf('__q') !== -1) {
      var parts = current.split('__q');
      var goalId = parts[0];
      var qIndex = parseInt(parts[1], 10);
      var followKey = this.followKeyFor(goalId);
      var question = (FOLLOWUPS[followKey] || [])[qIndex];
      if (question) {
        panel.appendChild(el('p', 'nsq__question', this.t(question.text)));
        panel.appendChild(this.renderOptionGrid(question.options, function (id) { self.answerQuestion(current, id); }, function (id) { return self.state.answers[current] === id; }));
      }
      panel.appendChild(this.renderNav());
    } else if (current === 'result') {
      this.renderResult(panel);
    }

    this.root.appendChild(panel);
  };

  Quiz.prototype.renderNav = function () {
    var self = this;
    var nav = el('div', 'nsq__nav');
    var back = el('button', 'nsq__back', this.t({ es: '← Atrás', en: '← Back' }));
    back.type = 'button';
    back.addEventListener('click', function () { self.goBack(); });
    nav.appendChild(back);
    return nav;
  };

  Quiz.prototype.renderOfferCard = function (item, tagText, isPrimary) {
    var self = this;
    var card = el('div', 'nsq__offer' + (isPrimary ? ' nsq__offer--primary' : ''));
    var img = el('img', 'nsq__offer-img');
    img.src = item.image;
    img.alt = this.t(item).name;
    img.loading = 'lazy';
    card.appendChild(img);
    var body = el('div', 'nsq__offer-body');
    body.innerHTML =
      '<span class="nsq__offer-tag">' + tagText + '</span>' +
      '<p class="nsq__offer-name">' + this.t(item).name + '</p>' +
      '<p class="nsq__offer-desc">' + this.t(item).desc + '</p>';
    var btn = el('button', 'nsq__offer-cta', this.t({ es: 'Añadir al carrito', en: 'Add to cart' }));
    btn.type = 'button';
    btn.addEventListener('click', function () {
      track('nsq_offer_clicked', { variant_id: item.variantId, handle: item.handle });
      addToCart(item.variantId, btn, self.locale);
    });
    body.appendChild(btn);
    card.appendChild(body);
    return card;
  };

  Quiz.prototype.renderResult = function (panel) {
    var self = this;
    track('nsq_result_shown', { goals: this.state.goals.join(','), gender: this.state.gender, locale: this.locale });

    panel.appendChild(el('p', 'nsq__result-head', this.t({ es: 'Según lo que nos compartió', en: 'Based on what you shared' })));
    panel.appendChild(el('h2', 'nsq__result-title', this.t({ es: 'Comience su viaje con NaturalSlim', en: 'Start your NaturalSlim journey' })));

    var offers = el('div', 'nsq__offers');
    offers.appendChild(this.renderOfferCard(FULL_PROGRAM, this.t({ es: 'Recomendado', en: 'Recommended' }), true));

    var resultKeys;
    if (this.state.goals.indexOf('all') !== -1) {
      resultKeys = ['all'];
    } else {
      resultKeys = GOAL_ORDER.filter(function (g) { return self.state.goals.indexOf(g) !== -1; })
        .map(function (g) { return self.followKeyFor(g); });
    }
    resultKeys.forEach(function (key) {
      var kit = KITS[key] || KITS.all;
      offers.appendChild(self.renderOfferCard(kit, self.t({ es: 'Para empezar más ligero', en: 'A lighter place to start' }), false));
    });

    panel.appendChild(offers);

    var restart = el('button', 'nsq__restart', this.t({ es: 'Empezar de nuevo', en: 'Start over' }));
    restart.type = 'button';
    restart.addEventListener('click', function () { self.restart(); });
    panel.appendChild(restart);
  };

  function init() {
    var roots = document.querySelectorAll('[data-nsq-root]');
    roots.forEach(function (root) {
      if (root.__nsqInitialized) return;
      root.__nsqInitialized = true;
      new Quiz(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target && evt.target.querySelector && evt.target.querySelector('[data-nsq-root]');
    if (root) {
      root.__nsqInitialized = false;
      init();
    }
  });
})();
